
<ng-template ssMobileToolbarContent>
    <div class="flex-row flex--justify-between flex--align-center flex-1">
        <h5 class="mat-headline-5 primary-contrast-text">{{'ss-routes.teams' | translate}}</h5>
        <button
            mat-icon-button
            (click)="showSearchSubject.next(!showSearchSubject.value)"
        >
        <mat-icon class="primary-contrast-text">search</mat-icon>
    </button>
    </div>
    
</ng-template>



<ng-template    #actionsTemplate let-element="element">

    <div class="flex-row flex--align-center">
        <button mat-icon-button color="warn" (click)="remove(element);$event.stopPropagation()"><mat-icon>delete</mat-icon></button>
    </div>

</ng-template>

<ng-template #toolbarTemplate>
    <div  class="display-block full-width">

        <button 
            *ngIf="!(isSmallerScreenObs | async);else iconBtn"
            mat-raised-button 
            color="primary" 
            (click)="navigateToNewTeam()"
        >
            <mat-icon>add</mat-icon>
            {{'ss-entities.team.new' | translate}}
        </button>
    
        <ng-template #iconBtn>
            <button 
                mat-raised-button 
                color="primary" 
                class="full-width"
                (click)="navigateToNewTeam()"
            >
                <mat-icon>add</mat-icon>
                {{'ss-entities.team.new' | translate}}
            </button>
    
        </ng-template>
    </div>
</ng-template>



<ss-data-grid   #gridRef
                [columns]="columns" 
                class="display-block full-height position-relative"
                gridTitle="ss-routes.teams"
                [showSearch]="showSearchSubject | async"
                [loadFn]="loadFnObs | async" 
                (rowClick)="routeToDetail($event)" 
                [actionsTemplate]="actionsTemplate"
                ssCoreLoaderOutlet
                [height]="'100%'"
                [keys]="['teams.get']" 
                [toolbarTemplate]="toolbarTemplate"
>
  
</ss-data-grid>